import PersonalEmployeeAttendanceDaily from "@/modules/personal/stores/attendance/personal_employee_attendance_daily";
import PersonalEmployeeAttendanceMonthly from "@/modules/personal/stores/attendance/personal_employee_attendance_monthly";

export default {
  modules: {
    PersonalEmployeeAttendanceDaily,
    PersonalEmployeeAttendanceMonthly,
  },
};
